import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";

export const getAllBookings = createAsyncThunk(
  "WebBooking/FindAllWebBooking",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebBooking/FindAllWebBooking`,
        formdata
      );

      const result = response.data?.Data;
      return result?.map((booking: any) => {
        return {
          ...booking,
          Name: `${booking?.FirstName} ${booking?.LastName}`,
        };
      });
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Booking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
